import { BaSeIcon, BaSeParagraph, BaSeStepper, BaSeTheme } from '@base/react';
import React from 'react';
import {
  Container,
  ImageResult,
  ImageWrapper,
  ResultBoxMessageWrapper,
  ResultTextMessagetWrapper,
  ResultTextSubTitle,
  ResultTextTitle,
  ResultWrapper,
  StepWrapper,
} from './result-content-styled';

// import { Container } from './styles';

function ResultFail() {
  const mapTitles = {
    title: 'Houve uma falha ao enviar o seu questionário!',
    subTitle: 'Procure o supervisor.',
  };

  const steps = React.useMemo(
    () => [
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: '',
      },
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: '',
      },
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: '',
      },
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: '',
      },
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: '',
      },
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: '',
      },
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: '',
      },
      {
        isCompleted: false,
        withError: true,
        isClickable: false,
        title: '',
      },
    ],
    [],
  );

  const isSuccess = false;

  function getIcon(success) {
    return success ? 'clock-three' : 'exclamation-octagon';
  }

  return (
    <div>
      <Container>
        <ResultWrapper>
          <StepWrapper>
            <BaSeStepper
              steps={steps}
              onStepChange={() => {}}
              activeWithErrorColor={BaSeTheme.colors.feedbackInterface.erro45}
              activeColor={BaSeTheme.colors.feedbackInterface.sucesso}
              completedColor={BaSeTheme.colors.feedbackInterface.sucesso70}
              orientation={'horizontal'}
            />
          </StepWrapper>
          <ResultBoxMessageWrapper isSuccess={isSuccess}>
            <BaSeIcon
              color={BaSeTheme.colors.defaultColors.white}
              description={isSuccess ? 'Success' : 'Error'}
              name={getIcon(isSuccess)}
              size={32}
            />
            <ResultTextMessagetWrapper>
              <ResultTextTitle>
                <BaSeParagraph
                  isBold
                  color={BaSeTheme.colors.defaultColors.white}
                >
                  {mapTitles['subTitle']}
                </BaSeParagraph>
              </ResultTextTitle>
              <ResultTextSubTitle>
                <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
                  {mapTitles['title']}
                </BaSeParagraph>
              </ResultTextSubTitle>
            </ResultTextMessagetWrapper>
          </ResultBoxMessageWrapper>

          <ImageWrapper>
            <ImageResult isSuccess={isSuccess} />
          </ImageWrapper>
        </ResultWrapper>
      </Container>
    </div>
  );
}

export default ResultFail;
